import React, { useRef } from "react";

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import useTranslation from "../../../hooks/useTranslation";
import { Skeleton } from "@mui/material";

const TopRatingSkeleton = () => {
  const { t } = useTranslation();
  const swiperRef = useRef();
  return (
    <div className="py-24 best-slider">
      <div className="flex w-full">
        <div className="flex flex-col items-center gap-16 w-full">
          <span className="text-xl text-dark font-bold uppercase tracking-[0.18em]">
            {t("les mieux notés")}
          </span>
          <div className="relative flex justify-center container mx-auto">
            <div className="max-w-full">
              <Swiper
                ref={swiperRef}
                slidesPerView={3}
                spaceBetween={35}
                loop={true}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  640: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                }}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
              >
                {[...Array(3).keys()].map((it, i) => (
                  <SwiperSlide key={i}>
                    <div className="block card">
                      <div
                        style={{
                          borderRadius: "30px",
                        }}
                        className="flex flex-col w-[346px] h-[457px] bg-white border border-[#BBBBBB] rounded-lg"
                      >
                        <div
                          style={{
                            borderRadius: "30px 30px 0px 0px",
                          }}
                          className="h-48 relative "
                        >
                          <div className="absolute z-10 right-4 top-4">
                            <div className="bg-white py-[6px] px-[9px] rounded-[100px] flex items-center gap-1">
                              <img
                                src="/svg/star.svg"
                                alt="star"
                                className="w-5 h-5 mb-[0.5px]"
                              />
                              <Skeleton width={15} />
                            </div>
                          </div>
                          <Skeleton
                            width={346}
                            className="w-full h-full"
                            variant="rectangular"
                            sx={{
                              backgroundColor: "#cec8c8",
                              borderRadius: "30px 30px 0px 0px",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            borderRadius: "0px 0px 30px 30px",
                          }}
                          className="px-7 py-3"
                        >
                          <div className="flex flex-col items-center gap-1 h-full ">
                            <Skeleton width={180} variant="rounded" />
                            <Skeleton width={80} variant="text" />

                            <p className="text-sm text-[#727272] line-clamp-3 h-[60px] w-full">
                              <Skeleton width={"100%"} variant="text" />
                              <Skeleton width={"100%"} variant="text" />
                              <Skeleton width={"60%"} variant="text" />
                            </p>
                            <div className="flex items-center gap-2 py-4 text-lg text-[#ADADAD]">
                              <svg
                                width="14"
                                height="16"
                                viewBox="0 0 14 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M7.39804 15.804C8.88097 15.0348 14 12.0163 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 12.0163 5.11903 15.0348 6.60196 15.804C6.85483 15.9351 7.14517 15.9351 7.39804 15.804ZM7 10C8.65685 10 10 8.65685 10 7C10 5.34315 8.65685 4 7 4C5.34315 4 4 5.34315 4 7C4 8.65685 5.34315 10 7 10Z"
                                  fill="#273B4A"
                                />
                              </svg>

                              <Skeleton width={160} variant="text" />
                            </div>
                            <div className="bg-secondary text-white py-[17px] w-full font-semibold text-xl rounded-lg ha:hover:bg-primary duration-300 text-center">
                              {t("Voir plus")}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopRatingSkeleton;
